import { useState } from "react";

import Stats from "@/components/stats";
import ProcessModal from "./process-modal";

export default function Details({ project, statements }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pagesRemaining, cost, pagesAfterProcessing } = project;

  const projectDetails = [
    {
      label: "Total # of statement pages",
      value: statements.metadata.numberOfPages,
    },
  ];

  return (
    <div className="mb-6 mt-4">
      <Stats title="Project details" items={projectDetails} cols={1} />

      <ProcessModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        projectDetails={{
          numberOfPages: statements.metadata.numberOfPages,
          pagesRemaining,
          pagesAfterProcessing,
          cost,
        }}
      />
    </div>
  );
}
